import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { shopPoliciesQueryOptions } from "@modules/shopify/hooks";
import { InfoPolicyBody } from "@modules/shop/components/InfoPage/InfoPolicyBody";
import { getCountryVariables } from "@/modules/shared/localization/const/countries";

export const Route = createFileRoute(
  "/$locale/_layout/(public)/_public/info/contact-information",
)({
  component: ContactInformationPage,
  ssr: true,
  loader: async ({ context: { queryClient }, params }) => {
    const localeVars = getCountryVariables(params.locale);
    return queryClient.ensureQueryData(shopPoliciesQueryOptions(localeVars));
  },
  staleTime: 60_000 * 60, // 1 hour
  headers: () => ({
    "Cache-Control":
      "public, max-age=3600, s-maxage=3600, stale-while-revalidate=86400",
  }),
  head: ({ params }) => {
    const t = i18n.getFixedT(params.locale);
    return {
      meta: [
        ...seo({
          title: t("Seo:contactInformation.title"),
          description: t("Seo:contactInformation.description"),
        }),
      ],
    };
  },
});

function ContactInformationPage() {
  const { locale } = Route.useParams();
  return (
    <InfoPolicyBody
      policyKey="contactInformation"
      locale={locale}
      titleKey="Footer.information.contactUs"
    />
  );
}
